import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j6hurcz92: FaireProductEntity = {
  token: "p_8j6hurcz92",
  type: "product",
  name: "Dirty Words Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/dca0430bd2523d7a249cdcc0cee083a73f3d80c2d798cf6ed30a8b40de408fd8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0aa26daa1dd9ae9826db7b09b626b8e5d12399675c7209fd57cbd6850884c8a.jpeg",
    "https://cdn.faire.com/fastly/0fe2e6fbc03415567a75087fe72baed761c4a91daf07e4d6d86be9c2516ea017.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8dfc02cd2f81b0c186edb96685044882a654486e452f65b349582d06c7435be4.jpeg",
    "https://cdn.faire.com/fastly/8d1424eb73f56b6c51807d46d8d2984e299e80750dc9cc91b887b62d51f9fe7d.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nYou can't say these 7 words on TV... but you're probably safe to say 'em on your socks (and most streaming services). If you always wanted to be nasty up to the ankle and comfy down to the toe, these MADE IN USA gray and black gym socks with a cushion foot are for you!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:09.292Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
